(() => {
  const money = value => new Intl.NumberFormat('en-GB', {style:'currency', currency:window.Shopify?.currency?.active || 'GBP'}).format(value / 100);
  function enhanceDetails() {
    document.querySelectorAll('[data-htl-product-information]').forEach(info => {
      if (info.dataset.ready) return;
      info.dataset.ready = 'true';
      const source = info.querySelector('[data-htl-description-source]');
      const specs = source.querySelector('[id="tab2"]');
      if (specs && specs.textContent.trim()) {
        const panel = info.querySelector('[data-htl-specifications]');
        info.querySelector('[data-htl-specifications-body]').append(specs);
        panel.hidden = false;
        const heading = info.querySelector('[data-htl-description] > summary');
        heading.textContent = heading.dataset.modelHeading;
      }
      info.querySelectorAll('tr').forEach(row => {
        const cells = row.querySelectorAll('th,td');
        if (cells.length >= 2 && /weight/i.test(cells[0].textContent) && /^(?:tbc|tba|to be confirmed)[.]?$/i.test(cells[1].textContent.trim())) cells[1].textContent = info.dataset.weightUnknown;
      });
      info.querySelectorAll('.tab_content').forEach((node, index) => {
        node.classList.remove('tab_content');
        node.classList.add('htl-product-detail-content');
        node.removeAttribute('id'); node.style.removeProperty('display');
        if (!node.textContent.trim() && !node.querySelector('img,video,iframe')) node.remove();
      });
    });
  }
  function init() {
    enhanceDetails();
    document.querySelectorAll('[data-htl-purchase]').forEach(wrap => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = 'true';
      const form = wrap.querySelector('[data-htl-buy-form]');
      const select = form.querySelector('[data-htl-buy-variant]');
      const reserve = form.querySelector('[data-htl-reserve]');
      const full = form.querySelector('[data-htl-full]');
      const error = wrap.querySelector('[data-htl-buy-error]');
      const copy = JSON.parse(wrap.querySelector('[data-htl-buy-copy]').textContent);
      const main = wrap.closest('.product-main');
      const deposit = Number(wrap.dataset.depositPrice);
      const extraFieldset = form.querySelector('[data-htl-extra-fieldset]');
      if (extraFieldset) extraFieldset.disabled = false;
      const extraInputs = [...form.querySelectorAll('[data-htl-extra], [data-htl-extra-select]')];
      extraInputs.forEach(input => input.dataset.originalDisabled = String(input.disabled));
      const finance = main.querySelector('[data-htl-finance]');
      function extras() {
        return extraInputs.flatMap(input => {
          const item = input.matches('select') ? input.selectedOptions[0] : input.checked ? input : null;
          const id = item && (item.dataset.variantId || item.value);
          return id ? [{id:Number(id), price:Number(item.dataset.price), label:item.dataset.label}] : [];
        });
      }
      function calculateFinance(price) {
        if (!finance) return;
        finance.dataset.price = price;
        finance.querySelector('[data-finance-price]').textContent = money(price);
        const downInput = finance.querySelector('[data-finance-deposit]');
        const aprInput = finance.querySelector('[data-finance-apr]');
        const down = downInput.valueAsNumber;
        const apr = aprInput.valueAsNumber;
        const term = Number(finance.querySelector('[data-finance-term]').value);
        const cash = price / 100;
        downInput.max = cash;
        const valid = Number.isFinite(down) && down >= 0 && down <= cash && Number.isFinite(apr) && apr >= 0 && apr <= 100;
        const error = finance.querySelector('[data-finance-error]');
        error.hidden = valid;
        finance.querySelector('[data-finance-result]').hidden = !valid;
        if (!valid) { error.textContent = 'Enter a deposit between £0 and the purchase total, and an APR between 0% and 100%.'; return; }
        const borrowed = cash - down;
        const rate = Math.pow(1 + apr / 100, 1 / 12) - 1;
        const monthly = rate === 0 ? borrowed / term : borrowed * rate / (1 - Math.pow(1 + rate, -term));
        finance.querySelector('[data-finance-monthly]').textContent = money(monthly * 100);
        finance.querySelector('[data-finance-borrowed]').textContent = money(borrowed * 100);
        finance.querySelector('[data-finance-interest]').textContent = money(Math.max(0, monthly * term - borrowed) * 100);
        finance.querySelector('[data-finance-total]').textContent = money((monthly * term + down) * 100);
      }
      finance?.addEventListener('input', () => calculateFinance(Number(finance.dataset.price)));
      function track(action) {
        if (wrap.dataset.role === 'main' && typeof window.clarity === 'function') window.clarity('event', 'htl_' + action);
      }
      function update(updateGallery = false) {
        const option = select.selectedOptions[0];
        const price = Number(option.dataset.price);
        const selectedExtras = extras();
        const total = price + selectedExtras.reduce((sum, extra) => sum + extra.price, 0);
        wrap.querySelector('[data-htl-order-total]').textContent = money(total);
        wrap.querySelector('[data-htl-order-extras]').textContent = selectedExtras.length ? copy.extras + ': ' + selectedExtras.map(extra => extra.label + ' (+' + money(extra.price) + ')').join(' · ') : copy.noExtras;
        const pumpSelect = form.querySelector('[data-htl-extra-select]');
        if (pumpSelect) {
          const photoId = pumpSelect.selectedOptions[0].dataset.productId;
          const photos = [...form.querySelectorAll('[data-htl-pump-photo]')];
          photos.forEach((photo, index) => photo.hidden = photoId ? photo.dataset.htlPumpPhoto !== photoId : index !== 0);
          pumpSelect.closest('.htl-extra-card').classList.toggle('is-selected', Boolean(pumpSelect.value));
        }
        calculateFinance(total);
        const available = option.dataset.available === 'true';
        full.disabled = !available;
        if (reserve) { reserve.disabled = !available; reserve.textContent = available ? copy.reserve : copy.soldOut; }
        wrap.querySelector('[data-htl-full-price]').textContent = money(total);
        wrap.querySelector('[data-htl-order-colour]').textContent = option.textContent.trim();
        wrap.querySelector('[data-htl-balance]').textContent = money(Math.max(0, total - deposit));
        const current = main.querySelector('[data-price-ui] .price .money');
        if (current) current.textContent = money(price);
        const compare = main.querySelector('[data-price-ui] .compare-at-price .money');
        if (compare) { compare.textContent = Number(option.dataset.compare) > price ? money(Number(option.dataset.compare)) : ''; }
        const media = option.dataset.mediaId;
        const gallery = main.querySelector('[data-product-gallery]');
        const carousel = gallery && (window.Flickity?.data(gallery) || window.jQuery?.(gallery).data('flickity'));
        if (updateGallery && carousel && media) carousel.selectCell('[data-media-id="' + media + '"]', false, true);
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(null, '', url);
      }
      extraInputs.forEach(input => input.addEventListener('change', () => { update(); track('product_extra'); }));
      select.addEventListener('change', () => { update(true); track('product_option'); });
      async function purchase(mode) {
        if (wrap.dataset.busy === 'true' || !form.reportValidity()) return;
        const option = select.selectedOptions[0];
        if (option.dataset.available !== 'true') return;
        const price = Number(option.dataset.price);
        const selectedExtras = extras();
        const total = price + selectedExtras.reduce((sum, extra) => sum + extra.price, 0);
        const properties = {};
        for (const [key,value] of new FormData(form).entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        }
        const stock = wrap.querySelector('[data-htl-stock]');
        if (stock) {
          properties['Supply status'] = stock.querySelector('[data-stock-title]').textContent;
          properties['Delivery information'] = stock.querySelector('[data-stock-note]').textContent;
        }
        if (selectedExtras.length) {
          properties['Selected extras'] = selectedExtras.map(extra => extra.label + ' (' + money(extra.price) + ')').join('; ');
          properties['Total including extras'] = money(total);
        }
        if (selectedExtras.some(extra => extra.label.includes('Upgrade included 5kW'))) properties['Included FREE'] = '5kW Elite heat pump credit applied toward the selected 7kW upgrade; fitting included';
        if (mode === 'reserve') {
          properties['Reserved product'] = wrap.dataset.title;
          properties['Colour / option'] = option.textContent.trim();
          properties['Full product price'] = money(price);
          properties['Reservation paid'] = money(deposit);
          properties['Remaining balance including extras'] = money(Math.max(0, total - deposit));
          if (selectedExtras.length) properties['_Reserved accessory variants'] = selectedExtras.map(extra => extra.id).join(', ');
          properties['Product URL'] = wrap.dataset.productUrl + '?variant=' + option.value;
          properties['_Reserved variant ID'] = option.value;
        }
        const items = [{id:Number(mode === 'reserve' ? wrap.dataset.depositId : option.value),quantity:1,properties}];
        if (mode === 'full') selectedExtras.forEach(extra => items.push({id:extra.id,quantity:1,properties:{'For product':wrap.dataset.title,'Colour / option':option.textContent.trim(),'_Parent variant ID':option.value}}));
        const button = mode === 'reserve' ? reserve : full;
        const previous = button.innerHTML;
        wrap.dataset.busy = 'true';
        select.disabled = true; extraInputs.forEach(input => input.disabled = true); full.disabled = true; if (reserve) reserve.disabled = true;
        button.textContent = copy.adding; button.setAttribute('aria-busy','true'); error.hidden = true;
        track(mode + '_start');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || copy.error);
          track(mode + '_added');
          location.assign(root + 'cart');
        } catch (e) {
          error.textContent = e.message || copy.error; error.hidden = false;
          button.innerHTML = previous; button.removeAttribute('aria-busy');
          select.disabled = false; extraInputs.forEach(input => input.disabled = input.dataset.originalDisabled === 'true'); wrap.dataset.busy = 'false'; update(); track('purchase_error');
        }
      }
      reserve?.addEventListener('click', () => purchase('reserve'));
      form.addEventListener('submit', e => {e.preventDefault(); purchase('full');});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
